import React from 'react';
import {projectBriefLength} from 'components/Commons/FieldTextarea';

export default function CartHeader({
  pagesIsExists,
  pagesIsNotExists,
  optionsWithPrice,
  optionsNoPriceIsExists
}) {
    let isHiddenText = pagesIsExists || (pagesIsNotExists && optionsWithPrice > 0 ) || (pagesIsNotExists && optionsNoPriceIsExists ) || (pagesIsNotExists && projectBriefLength > 0);

  return (
    <div className="app-cart-header">
      <h3 className="app-cart-header-text">
          Summary
      </h3>
      <div className={`app-cart-header-text-additional ${(isHiddenText) ? 'is-hidden' : ''}`}>
          {(isHiddenText) ? '' : 'Choose your options on the left and provide project details.'}
      </div>
    </div>
  )
}
